export const OTP_CODE_LENGTH = 6
export const RESEND_COOLDOWN_SECONDS = 60
export const OAUTH_SESSION_STORAGE_KEY = 'oauth_params'
